import axios, { AxiosError } from 'axios';
import { makeUseAxios } from 'axios-hooks';
import HttpStatusCode from './HttpStatusCode';
import { renderErrors } from '../helper/error-message-helper';
import DEVELOPMENT_CONFIG from "../helper/config";
import { calcOffMins, getTimeZone } from 'src/util/utility';


export const customAxios = axios.create({
  baseURL: DEVELOPMENT_CONFIG.base_url,
  headers: {
    'Content-Type': 'application/json',
  },
});


customAxios.interceptors.request.use(
  async (config) => {
    const accessToken = await localStorage.getItem("token");
    if (accessToken && config.headers) {
      config.headers['Authorization'] = 'Bearer ' + accessToken;
      config.headers['OffSetMins'] = calcOffMins();
      config.headers['userTimeZone'] = getTimeZone()
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);


customAxios.interceptors.response.use(
  async (resp) => {

    switch (resp.data.statusCode) {
      case HttpStatusCode.OK:
        if (resp.status) {
          return resp.data;
        } else {
          renderErrors(resp.data.message)
        }
        break;

      case HttpStatusCode.BAD_REQUEST:
        if (resp?.data?.resultData) {
          throw resp?.data?.resultData;
        }

        return Promise.reject(resp?.data?.message ? resp?.data?.message : 'Invalid Request: Your request could not be processed. Please check the input and try again.');

        break;

      case HttpStatusCode.UNAUTHORIZED:
        localStorage.clear();
        window.location.href = "/login";
        renderErrors(resp.data.message)
        break;

      case HttpStatusCode.NOT_FOUND:
        renderErrors(resp.data.message)
        break;

      case HttpStatusCode.INTERNAL_SERVER_ERROR:
        if (resp?.data?.message) {
          throw resp?.data;
        }
        renderErrors(resp.data.message)
        break;

      case HttpStatusCode.NOT_IMPLEMENTED:
        renderErrors(resp.data.message)
        break;

      case HttpStatusCode.FORBIDDEN:
        return Promise.reject('You are not eligible to access this resourse');
        break;

      case HttpStatusCode.BAD_GATEWAY:
        renderErrors('Unable to connect to server please try again...')
        break;
    }
  },
  (error: AxiosError) => {
    try {
      if (error?.status === HttpStatusCode.UNAUTHORIZED) {
        localStorage.clear();
        window.location.href = "/login";
      }
      else if (['NETWORK_ERROR', 'ERR_NETWORK'].includes(error?.code ?? '')) {
        renderErrors('Unable to connect to server')
        return Promise.reject('Unable to connect to server please try again...');
      }
      else {
        try {
          renderErrors((error?.response?.data as Object)['Message'])
        } catch (E) { }
      }
    } catch (E) {

      Promise.reject(error);
    }
  }
);



export const useExpressApi = makeUseAxios({
  cache: false,
  axios: customAxios,
});

